import { render, staticRenderFns } from "./ConfirmationSwapTransactionDetails.vue?vue&type=template&id=1aa25ee2&"
import script from "./ConfirmationSwapTransactionDetails.vue?vue&type=script&lang=js&"
export * from "./ConfirmationSwapTransactionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports